export default "__VITE_ASSET__D44taKKz__"